<template>
  <!--页面的底部-->
  <div class="footer" v-if="links && links.length">
    <!-- <div class="footer-title">友情链接</div> -->
    <div class="navs">
      <a
        :href="target_url"
        v-for="{ name, target_url, id } in links"
        :key="id"
        target="_blank"
        class="nav"
        >{{ name }}</a>
    </div>
    <!-- <div class="navs-text">
      <a>{{ footer }}</a>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {
    menu: Object
  },
  data() {
    return { links: []};
  },
  created() {
    this.getLink();
  },
  methods: {
    async getLink() {
      const res = await this.$http.getFooterLink({ num: this.menu.num });
      this.links = res;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  height: 80px;
  width: 100%;
  text-align: center;
  padding: 20px 0 20px;
  background: transparent;
  &-title {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 500;
    margin-bottom: 12px;
  }
}

.footer .navs {
  margin-bottom: 12px;
}

.footer .navs .nav {
  display: inline-block;
  padding: 3px 15px;
  // border: 1px solid rgba(255,255,255,0.24);
  margin-left: 20px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #FFFFFF;
  font-weight: 400;
  &:first-child {
    margin-left: 0;
  }
}

.navs-text{
font-weight: 400;
font-size: 12px;
color: rgba(255,255,255,0.5);
line-height: 16px;
display: block;
justify-content: center;
}
// .footer .navs .nav + .nav {
//   margin-left: 20px;
// }

// .foot {
//   font-size: 14px;
//   color: #707070;
//   line-height: 20px;
//   text-align: center;
//   margin: 0 auto;
// }
</style>